const REPORT_EVENTS = {
  ICON_SHOWN: 'ICON_SHOWN',
  SEEN: 'SEEN',
};

export { REPORT_EVENTS };
